// extracted by mini-css-extract-plugin
export default {"pdf-slide":"styles_pdf-slide__WfIM9"};